import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  actionLink?: string;
  icon?: React.ReactNode;
}
const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionLabel,
  actionLink,
  icon
}) => {
  return <div className="py-12 flex flex-col items-center justify-center text-center px-4" data-id="element-28">
      <div className="rounded-full bg-gray-100 p-6 mb-4" data-id="element-29">{icon}</div>
      <h3 className="text-lg font-medium text-gray-900 mb-1" data-id="element-30">{title}</h3>
      <p className="text-gray-500 mb-6 max-w-md" data-id="element-31">{description}</p>
      {actionLabel && actionLink && <Link to={actionLink} className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-32">
          <PlusIcon className="h-5 w-5 mr-1" data-id="element-33" />
          <span data-id="element-34">{actionLabel}</span>
        </Link>}
    </div>;
};
export default EmptyState;